import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { rem } from 'polished'
import React, { useCallback } from 'react'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { LFSEOfferType, LOOKING_FOR_SOMETHING_ELSE_CONTENT } from 'home/components/LookingForSomethingElse/constants'
import TextButton from 'LuxKit/Button/TextButton'
import * as Analytics from 'analytics/analytics'
import { getThemeClassName } from 'lib/theme/themeUtils'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Typography from 'LuxKit/Typography/Typography'

const Container = styled(Group)`
  background-color: ${props => props.theme.palette.neutral.default.seven};
  padding-left: ${rem(20)};
  padding-right: ${rem(20)};
  height: 100%;
  width: ${rem(388)};

  ${mediaQueryUp.tablet} {
    padding-left: ${rem(40)};
    padding-right: ${rem(40)};
  }
`

interface Props {
  offerType: LFSEOfferType;
  link?: string;
}

function HeroOfferCarouselLookingForSomethingElse({ offerType, link }: Props) {
  const { to, label } = LOOKING_FOR_SOMETHING_ELSE_CONTENT[offerType]

  const onClickViewAll = useCallback(() => {
    Analytics.trackClientEvent({
      action: 'pressed',
      subject: `topexclusive-carousel-${offerType}-viewall`,
      category: 'vertical_page',
      type: 'interaction',
    })
  }, [offerType])

  return (
    <Container direction="vertical" horizontalAlign="center" verticalAlign="center" className={getThemeClassName({ mobile: 'inverse' })}>
      <Typography align="center">
        <VerticalSpacer gap={8}>
          <Heading align="center" variant="heading5">Looking for something else?</Heading>
          <VerticalSpacer gap={24}>
            <BodyText colour="neutral-two" align="center" variant="medium">Browse all destinations or {label ?? 'products'} for more amazing offers</BodyText>
            <TextButton kind="primary" size="medium" shape="square" to={link ?? to} onClick={onClickViewAll}>
              View all
            </TextButton>
          </VerticalSpacer>
        </VerticalSpacer>
      </Typography>
    </Container>
  )
}

export default HeroOfferCarouselLookingForSomethingElse
